import { useState } from "react";

import { ScopeType } from "sockapi/scope-types";
import { AdminQueueTaskSummary } from "sockapi/scope-specs/admin-queue-spec";
import { useGlobalScopeState } from "stores/ScopeStateStore";
import { LargeSpinner } from "components/Loading";
import PageChanger from "components/PageChanger";
import { AdminQueueTaskSummaryDisplay } from "components/AdminQueue/AdminQueueTaskSummaryDisplay";

function AdminQueueTaskListDisplay(props: {
  taskFilter: (entry: [string, AdminQueueTaskSummary]) => boolean;
  numTasksPerPage: number;
  pageNumStore?: [number, (pageNum: number) => void];
}) {
  const { taskFilter, numTasksPerPage, pageNumStore } = props;
  const adminQueueScopeState = useGlobalScopeState(ScopeType.ADMIN_QUEUE);
  const localPageNumStore = useState(0);
  const [storedPageNum, setPageNum] = pageNumStore ?? localPageNumStore;

  if (adminQueueScopeState === null) return <LargeSpinner />;

  const sortedTasks = Object.entries(adminQueueScopeState.tasks)
    .filter(taskFilter)
    .sort(([taskId1, task1], [taskId2, task2]) => {
      // Sort open tasks first.
      const isOpen1 = task1.respondTime === undefined;
      const isOpen2 = task2.respondTime === undefined;
      const diffIsOpen = (isOpen1 ? 0 : 1) - (isOpen2 ? 0 : 1);
      if (diffIsOpen !== 0) return diffIsOpen;

      // If the tasks are closed, sort by respond time, latest first.
      if (task1.respondTime !== undefined && task2.respondTime !== undefined)
        return task2.respondTime - task1.respondTime;

      // Otherwise, sort by request time.
      return task2.requestTime - task1.requestTime;
    });
  const pageNum =
    sortedTasks.length <= 0
      ? 0
      : Math.min(
          storedPageNum,
          Math.floor((sortedTasks.length - 1) / numTasksPerPage)
        );

  if (sortedTasks.length <= 0) return <div>No tasks found matching query.</div>;

  return (
    <>
      <div className="admin-queue-list">
        {sortedTasks
          .slice(pageNum * numTasksPerPage, (pageNum + 1) * numTasksPerPage)
          .map(([taskId, task]) => (
            <AdminQueueTaskSummaryDisplay
              key={taskId}
              taskId={taskId}
              taskSummary={task}
            />
          ))}
      </div>
      <div className="admin-queue-footer">
        <PageChanger
          numPerPage={numTasksPerPage}
          pageNum={pageNum}
          setPageNum={setPageNum}
          numEntries={sortedTasks.length}
        />
      </div>
    </>
  );
}

export default AdminQueueTaskListDisplay;
